import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Code, Actions, API, Utility, Button, Messages, Control } from 'helpers/PrintImports';
import { Client } from 'models/ClientModel';
import { Company } from 'models/CompanyModel';
import { Location } from 'models/LocationModel';
import { Insurance } from 'models/InsuranceModel';
import SignaturePad from "components/common/SignManager";
import { data, useSearchParams } from 'react-router-dom';

const ConsentPrint16: React.FC = () => {
  const titleName = 'Telus Health';
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [clientData, setClientData] = useState<Client>({});
  const [signData, setSignData] = useState<string>('');
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverPhone, setReceiverPhone] = useState<string>('');
  const [memberId, setMemberId] = useState<string>('');
  const [policyNumber, setPolicyNumber] = useState<string>('');
  const [groupNumber, setGroupNumber] = useState<string>('');
  const [insurerName, setInsurerName] = useState<string>('');
  const [primaryHolder, setPrimaryHolder] = useState<string>('');
  const [secondaryHolder, setSecondaryHolder] = useState<string>('');
  //const [companyData, setCompanyData] = useState<Company | null>(null);
  const [locationData, setLocationData] = useState<Location | null>(null);
  const [insuranceData, setInsuranceData] = useState<Insurance[]>([]);

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const today = Utility.Date.Current();

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyName = Utility.Storage.CompanyName();
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();


  useEffect(() => {
    if(!clientId) return;
    API.Data.GetByKeyId<Client>(formName, clientId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setClientData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      //const company = await API.Data.GetCompany(companyId);
      //if(company){ setCompanyData(company); }
      const location = await API.Data.GetLocationCity(locationId);      
      if(location){ setLocationData(location); }
      setReceiverName(Utility.Get.FullName(data,Code.Form.Name.CLIENT))
      setReceiverPhone(data.client_phone || '')
      callInsuranceList(data.client_id)
    }})
    setLoading(false);
  }, []); 

  const callInsuranceList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.INSURANCE, 1, Name.Insurance.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Insurance.Id,
        Name.Insurance.PolicyNumber, 
        Name.Insurance.memberNumber, 
        Name.Insurance.GroupNumber, 
        Name.Insurance.PrimaryHolderName, 
        Name.Insurance.SecondaryHolderName, 
        Name.Insurance.PrimaryRelationship, 
        Name.Insurance.SecondaryRelationship, 
        Name.Insurer.Name,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Insurance>(url, setInsuranceData, setError, setLoading);
  };

  useEffect(() => {
  if (insuranceData && insuranceData.length > 0) {
    const firstRow = insuranceData[0];
    setMemberId(firstRow.insurance_member_number || '');
    setPolicyNumber(firstRow.insurance_policy_number || '');
    setGroupNumber(firstRow.insurance_group_number || '');
    setInsurerName(firstRow.insurer_name || '');
    setPrimaryHolder(firstRow.primary_holder_name || '');
    setSecondaryHolder(firstRow.secondary_holder_name || '');
  }
}, [insuranceData]);

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={'TELUS'} showModify={false} Privilege={Privilege} clientData={clientData} fileName={titleName} docType={Code.Option.DocumentType.TELUS} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <div className="telus-consent">
              <div className="box"><img className='fright' src="/assets/images/basic/telus-health.png"></img> </div>
              <div className="box">
                  <p className="telus-heading">Electronic transmission authorization<br />and consent form</p>
              </div>
              <div className="box tac consent">
                  <p>Instructions: This form must be filled out when claims are submitted electronically by the provider on the patient’s behalf.                             Please retain this form in the patient’s file for verification purposes for two years following closure of the patient file.</p>
              </div>
              <table className='telus-table'>
                  <tr>
                      <td className="telus-title" colSpan={3}>Provider</td>
                  </tr>
                  <tr>
                      <td colSpan={3}>
                          <span>First and last name or clinic name</span>
                          <span className="telus-field" contentEditable>{companyName}</span>
                      </td>
                  </tr>
                  <tr>
                      <td colSpan={3}>
                          <span>Address</span>
                          <span className="telus-field" contentEditable>{locationData?.location_address}</span>
                      </td>
                  </tr>
                  <tr>
                      <td className="col1">
                          <span>City</span>
                          <span className="telus-field" contentEditable>{locationData?.city_name}</span>
                      </td>
                      <td className="col2">
                          <span>Province</span>
                          <span className="telus-field" contentEditable style={{ minWidth: '80px' }}>AB</span>
                      </td>
                      <td className="col3">
                          <span>Postal code</span>
                          <span className="telus-field"contentEditable>{locationData?.location_postal}</span>
                      </td>
                  </tr>
                  <tr>
                      <td className="telus-title" colSpan={3}>Patient</td>
                  </tr>
                  <tr>
                      <td className="col1">
                          <span>First name</span>
                          <span className="telus-field" contentEditable>{clientData.client_first_name} {clientData.client_middle_name}</span>
                      </td>
                      <td className="col1" colSpan={2}>
                          <span>Last name</span>
                          <span className="telus-field" contentEditable>{clientData.client_last_name}</span>
                      </td>
                  </tr>
                  <tr>
                      <td className="col1">
                          <span>Primary coverage insurer/payer</span>
                          <span className="telus-field" contentEditable>{insurerName}&nbsp;</span>
                      </td>
                      <td className="col1" colSpan={2}>
                          <span>Primary coverage plan member name</span>
                          <span className="telus-field" contentEditable>{primaryHolder}&nbsp;</span>
                      </td>
                  </tr>
                  <tr>
                      <td colSpan={3}>
                          <span>Primary coverage policy number (also referred to as group or contract number)</span>
                          <span className="telus-field" contentEditable>{policyNumber ? policyNumber : groupNumber}&nbsp;</span>
                      </td>
                  </tr>
                  <tr>
                      <td colSpan={3}>
                          <span>Primary coverage certificate (also referred to as member/identification number)</span>
                          <span className="telus-field" contentEditable>{memberId}&nbsp;</span>
                      </td>
                  </tr>
                  <tr>
                      <td colSpan={3}>
                          <span>(Canada Life only) secondary coverage plan member name</span>
                          <span className="telus-field" contentEditable>{secondaryHolder}&nbsp;</span>
                      </td>
                  </tr>
              </table>
              <div className="box">
                  <p className="fwb fs16i telus-color">Consent to collect and exchange personal information</p>
              </div>
              <div className="box">
                  <p className="fwb fs16i">Purpose</p>
              </div>
              <div>
                  <p>Personal information that we collect and disclose about you, and if applicable, is used by the insurer, and/or plan administrator of your group benefits plan, its affiliates and their service provider(s) for the purposes of assessing eligibility for your claims, underwriting, investigating, auditing and otherwise administering the group benefits plan, including the investigation of fraud and / or plan abuse and for internal data management and data analytical purposes.</p>
              </div>
              <div className="box">
                  <p className="fwb fs16i">Authorization and consent</p>
              </div>
              <div>
                  <p>I authorize my healthcare provider to collect, use and disclose personal information concerning any claims submitted on my behalf with the insurer and/or plan administrator and their service provider(s) for the above purposes</p>
                  <p>I authorize such insurer and / or plan administrator and their service provider(s) to:</p>
                  <ol>
                      <li>use my personal information for the above purposes.</li>
                      <li>exchange personal information with any individual or organization, including healthcare professionals, investigative agencies, insurers and reinsurers, and administrators of government benefits, or other benefits programs, other organizations, or service providers working with such insurer and/or plan administrator or any of the foregoing, when relevant for the above purposes.</li>
                      <li>where applicable exchange personal information concerning any claims with any assignee of benefits payable and exchange personal information for the above purposes electronically or in any other manner.</li>
                  </ol>
                  <p>I understand that personal information may be subject to disclosure to those authorized under applicable law.</p>
                  <p>I agree that a photocopy or electronic version of this authorization shall be as valid as the original, and may remain in effect for the continued administration of the group benefits plan.</p>
                  <p>In the event there is suspicion and/or evidence of fraud and/or plan abuse concerning any claims submitted, I acknowledge and agree that the insurer and/or plan administrator and their service provider(s) may use and disclose relevant personal information to any relevant organization including law enforcement bodies, regulatory bodies, government organizations, medical suppliers and other insurers, and where applicable my employer or benefit plan sponsor, for the purposes of investigation and prevention of fraud and/or benefit plan abuse. I understand that the submission of fraudulent claims is a criminal offence.</p>
                  <p>If there is an overpayment, I authorize the recovery of the full amount of the overpayment from any amount payable under the group benefits plan, and the exchange of personal information with other persons or organizations, including credit agencies and, where applicable, my benefit plan sponsor, for that purpose.</p>
                  <p>If the patient is a person other than myself, I confirm that the patient has given their consent to provide their personal information for the healthcare provider and the insurer and/or plan administrator and their service provider(s) to use and disclose their personal information as set out above</p>
                  <p></p>
              </div>
              <div className="box">
                  <p><input type="checkbox" checked={true} /> I accept the terms and conditions</p>
              </div>
              <div className="box">
                  <p className="fwb fs18 color">Benefit assignment form</p>
              </div>
              <div className="box">
                  <p>I hereby assign benefits payable for the eligible claims to the healthcare provider responsible for submitting my claims electronically to the group benefits plan and I authorize the insurer/plan administrator to issue payment directly to such provider. In the event my claim(s) are declined by the insurer/plan administrator, I understand that I remain responsible for payment to the healthcare provider for any services rendered and/ or supplies provided.</p>
                  <p>I acknowledge and agree that the insurer/plan administrator is under no obligation to accept this benefit assignment form, that any benefit payment made in accordance with this benefit assignment form will discharge the insurer/plan administrator of its obligations with respect to that benefit payment, and that in the event the benefit payment is made to me, the insurer/plan administrator will also be discharged of its obligation with respect to that benefit payment.</p>
                  <p>I understand that this assignment will apply to all eligible claims submitted electronically by my healthcare provider and that I may revoke it at any time by providing written notice to the insurer/plan administrator.</p>
                  <p>If I am a spouse or dependent, I confirm that I am authorized by the plan member to execute an assignment of benefit payments to the healthcare provider.</p>
              </div>
              <div className="box">
                  <p><input type="checkbox" checked={true} /> I accept the terms and conditions</p>
              </div>
              <div className='fbox'>
                <div className='flcol fleft pt4'>
                  <div className="box fs16i"><strong>Date:</strong><span contentEditable>{Utility.Date.getLocalDate().toISOString().split('T')[0]}</span></div>
                </div>
                <div className='flcol fright'>
                  <SignaturePad signData={signData} setSignData={setSignData} receiverName={receiverName} setReceiverName={setReceiverName} receiverPhone={receiverPhone} setReceiverPhone={setReceiverPhone} />
                </div>
              </div>
              <div className="box">
                  <p>All information contained herein is protected by privacy laws including the Personal Information Protection and Electronic Documents Act (PIPEDA) and all the corresponding provincial legislation. All users agree to protect the personal health information contained herein from unauthorized use, disclosure, loss, theft, or compromise in accordance with the above noted laws and with at least the same care employed to protect their own confidential information. Any unauthorized access, disclosure or use of this information is illegal.</p>
              </div>
            </div>
            {/* <Field.PrintedOn fixed={false} /> */}
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      {/* <Actions.Print /> */}
    </Control.Print.Frame>
  );
};

export default ConsentPrint16;